import React from 'react';
import VanishingPoint from './VanishingPoint';

function App() {
  return <VanishingPoint />;
}

export default App;